



























































































































































import Vue from "vue";
import axios from "axios";
import moment from "moment";

import { getDaysCountToEndDate } from "@/utils/momentUtils";
import { getUserNickName } from "@/utils/labelUtils";
import { defaultIconUrl, securityCheck } from "@/properties";

import Editor from "@/parts/review/Editor.vue";
import ReviewHeader from "@/parts/review/ReviewHeader.vue";
import ReturnTop from "@/parts/util/ReturnTop.vue";
import SimpleTooltip from "@/parts/util/SimpleTooltip.vue";
import {
  CorporateReviewForm,
  toCreateReviewRequestFromReviewForm,
  toUpdateReviewRequestFromReviewForm,
} from "@/views/corporate/review/ReviewForm";

import { getUserProfile } from "@/api/UserProfile";
import { createReview, updateReview, updateReviewStatus, registerZipFile } from "@/api/ReviewCorporate";
import { UserProfile, GetUserProfileResponse } from "@/api/dto/UserProfile";
import { Code, ZipFile, GithubUrl } from "@/api/dto/CorporateDealType";
import { Draft, UnderReview, AgreementPending, InReview, Completed } from "@/views/corporate/forms/DealStatus";
import { ReviewResponse, RegisterCorporateReviewCommentZipFile } from "@/api/dto/ReviewCorporate";
import { CodeEditorSegmegment } from "@/api/dto/CodeEditor";
import { ErrorResponse } from "@/api/dto/Error";

export default Vue.extend({
  name: "CorpConfirm",
  components: {
    Editor,
    ReviewHeader,
    ReturnTop,
    SimpleTooltip,
  },
  data() {
    return {
      defaultIconUrl,
      reviewData: {} as CorporateReviewForm,
      file: null as File | null,
      fileName: "",
      profileData: {} as GetUserProfileResponse,
      getUserNickName,
      alertList: [] as number[][],
      // モーダル 関連
      modalOpen: false,
      leaveModal: false,
      confirmModal: false,
      completeModal: false,
      // 汎用
      allowLeave: false,
      goBack: false,
      nextPath: "",
      isEnlarge: false,
      // 取引種別
      codeType: Code,
      zipFileType: ZipFile,
      githubUrlType: GithubUrl,
      // 取引状態
      draft: Draft,
      underReview: UnderReview,
      agreementPending: AgreementPending,
      inReview: InReview,
      completed: Completed,
    };
  },
  created() {
    this.initData();
  },
  async beforeRouteLeave(to, from, next) {
    if (!this.$browserBackFlg) {
      // ブラウザバック以外の場合
      // ガイド.よくある質問は別タブ
      if (to.path == "/guide" || to.path == "/faq") {
        window.open(to.path, "_blank");
        return;
      }
    }
    if (!this.allowLeave) {
        this.goBack = this.$browserBackFlg;
        this.leaveModalOpen(to.path);
        next(false);
        return;
    }
    if (to.name != "CorpReviewDraft" && to.name != "CorpReviewEdit") {
      this.$store.dispatch("initCorporateReviewForm");
      this.$store.dispatch("initCorporateReviewFile");
    }
    this.allowLeave = false;
    next();
  },
  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    formattedPurchaseOverview(): string {
      const urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;
      return this.reviewData.purchaseOverview.replace(urlRegex, (url: string) => {
        return `<a href="${url}" target="_blank">${url}</a>`;
      });
    },
    formattedCodeEditor(): {} {
      const urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;
      return this.reviewData.codeEditor.map((item) => {
        return {
          ...item,
          remarks: item.remarks.replace(urlRegex, (url: string) => {
            return `<a href="${url}" target="_blank">${url}</a>`;
          }),
        };
      });
    },
    dealId(): string {
      return this.$route.params.dealId;
    },
    isNewReview(): boolean {
      return this.$route.path == "/corporate/confirm";
    },
    hasAlert(): boolean {
      return this.alertList.some((s) => s.length > 0);
    },
    nickname(): string {
      return getUserNickName(this.loginData.nickname, this.loginData.userId);
    },
    isEnlarged(): boolean {
      return this.isEnlarge;
    },
    /**  ステータスに応じた文言を返却 */
    statusLabel(): string {
      switch (this.reviewData.dealStatus) {
        case Draft:
          return "下書き";
        case UnderReview:
          return "査定中";
        case AgreementPending:
          return "承諾待ち";
        case InReview:
          return "レビュー中";
        case Completed:
          return "完了";
        default:
          return "";
      }
    },
  },
  methods: {
    async initData() {
      var storeReviewForm = this.$store.getters.corporateReviewForm as CorporateReviewForm;
      this.file = this.$store.getters.corporateReviewFile as File;
      if (this.file) {
        this.fileName = this.file.name;
      }
      if (storeReviewForm.dealId == this.dealId && storeReviewForm.title) {
        this.reviewData = JSON.parse(JSON.stringify(storeReviewForm));
        this.getUserProfile();
        this.alertList = this.reviewData.codeEditor.map((segment) => this.checkCode(segment));
      } else {
        this.allowLeave = true;
        if (this.isNewReview) {
          this.$router.replace({ name: "CorpReviewDraft" });
        } else {
          this.$router.replace({ name: "CorpReviewEdit", params: { dealId: this.dealId } });
        }
      }
    },
    /** 経過時間の割り出し処理 */
    convertToElapsedDate(createDate?: string): string {
      if (!createDate) {
        return "-";
      }
      let posted = new Date(createDate);
      // 差分 = 現在の日時 - 投稿日時
      let diff = new Date().getTime() - posted.getTime();
      // 経過時間をDateに変換
      let progress = new Date(diff);
      let text = "";

      if (progress.getUTCFullYear() - 1970) {
        text = progress.getUTCFullYear() - 1970 + "年前";
      } else if (progress.getUTCMonth()) {
        text = progress.getUTCMonth() + "ヶ月前";
      } else if (progress.getUTCDate() - 1) {
        text = progress.getUTCDate() - 1 + "日前";
      } else if (progress.getUTCHours()) {
        text = progress.getUTCHours() + "時間前";
      } else if (progress.getUTCMinutes()) {
        text = progress.getUTCMinutes() + "分前";
      } else {
        text = "たった今";
      }
      return text;
    },
    convertToDateOnly(createDate?: string) {
      if (!createDate) {
        return "-";
      }

      return new Date(createDate).toLocaleDateString();
    },
    /**
     * セキュリティチェックを行い, 該当行を返す
     */
    checkCode(segment: CodeEditorSegmegment): number[] {
      const individual = securityCheck.individual.find((v) => v.extension == segment.extension);
      const lines: number[] = [];
      segment.text.forEach((line, i) => {
        const check1 = securityCheck.common.find((v) => line.code.indexOf(v) != -1);
        const check2 = individual?.word.find((v) => line.code.indexOf(v) != -1) ?? false;
        if (check1 || check2) {
          lines.push(i + 1);
        }
      });
      return lines;
    },
    async getUserProfile() {
      try {
        const res = await getUserProfile();
        this.profileData = res;
      } catch (e) {
        console.log(e);
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message == null) {
            this.$emit("errorToast", "ユーザー情報の取得に失敗しました。しばらく経ってからやり直してください。");
          } else {
            this.$emit("errorToast", resError.message);
          }
        }
      }
    },
    /** DL URLからファイル名を抽出 */
    extractionFileName(url: string): string | null {
      const regex = /\/([^/]+\.zip)_/;
      const match = url.match(regex);
      if (match) {
        return match[1];
      } else {
        return null;
      }
    },
    // モーダル 関連
    leaveModalOpen(path: string) {
      this.modalOpen = true;
      this.leaveModal = true;
      this.nextPath = path;
    },
    confirmModalOpen() {
      this.modalOpen = true;
      this.confirmModal = true;
    },
    completeModalOpen() {
      this.modalOpen = true;
      this.completeModal = true;
    },
    modalClose() {
      this.modalOpen = false;
      this.leaveModal = false;
      this.confirmModal = false;
    },
    /** レビューを公開（依頼） */
    submit() {
      this.reviewSubmit("settlement");
    },
    /** 公開したページ（詳細）へ遷移 */
    toReview() {
      this.$router.push({
        name: "CorpReview",
        params: { dealId: this.reviewData.dealId as string },
      });
    },
    /** 取引管理へ遷移 */
    toDealsManagement() {
      this.$router.push({ name: "DealsManagement" });
    },
    /** 編集画面へ戻る */
    gobackEdit() {
      this.$store.dispatch("updateCorporateReviewForm", { form: this.reviewData });
      if (this.file) {
        this.$store.dispatch("uploadCorporateReviewFile", this.file);
      }
      this.allowLeave = true
      if (this.reviewData.dealId) {
        this.$router.push({ name: "CorpReviewEdit", params: { dealId: this.reviewData.dealId!, from: "Confirm" } });
      } else {
        this.$router.push({ name: "CorpReviewDraft", params: { dealId: this.reviewData.dealId!, from: "Confirm" } });
      }
    },
    /** 破棄 */
    destroy() {
      this.modalClose();
      this.$store.dispatch("initCorporateReviewForm");
      this.$store.dispatch("initCorporateReviewFile");
      this.allowLeave = true;
      this.$router.push({ name: "CorpRequest" });
    },
    /** ページ離脱による下書き保存 or 編集内容を保存 */
    saveLeave() {
      this.reviewSubmit("save");
    },
    /** レビュー送信（汎用） */
    async reviewSubmit(action: string) {
      this.modalClose();
      if (action == "save") {
        // 下書き・編集内容の保存の場合
        try {
          if (this.isNewReview) {
            // レビュー新規作成（取引ステータス:下書き）
            var res = await createReview(toCreateReviewRequestFromReviewForm(this.reviewData, Draft));
            this.reviewData.dealId = res.dealId;
            await this.updateZipFile(this.reviewData.dealId);
            this.$emit("toast", "下書き保存しました");
          } else {
            // レビュー更新（取引ステータス:変更なし）
            await updateReview(
              this.reviewData.dealId as string,
              toUpdateReviewRequestFromReviewForm(this.reviewData, this.reviewData.dealStatus)
            );
            await this.updateZipFile(this.dealId);
            this.$emit("toast", "編集内容を保存しました");
          }
          this.destroy();
        } catch (e) {
          console.log(e);
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit("errorToast", "レビューの保存に失敗しました。しばらく経ってからやり直してください。");
            } else {
              this.$emit("errorToast", resError.message);
            }
          }
        }
      } else if (action == "settlement") {
        // 新規依頼・編集内容を公開する場合
        try {
          if (this.reviewData.dealId) {
            // レビュー更新
            await updateReview(
              this.reviewData.dealId as string,
              toUpdateReviewRequestFromReviewForm(this.reviewData, this.reviewData.dealStatus)
            );
            await this.updateZipFile(this.dealId);
            // レビューステータス更新（下書き -> 査定中）
            if (this.reviewData.dealStatus == Draft) {
              await updateReviewStatus(this.reviewData.dealId as string, { dealStatus: UnderReview });
            }
          } else {
            // レビュー作成（取引ステータス:下書き ->　査定中）
            var res = await createReview(toCreateReviewRequestFromReviewForm(this.reviewData, UnderReview));
            this.reviewData.dealId = res.dealId;
            await this.updateZipFile(this.reviewData.dealId);
          }
          // フォームの初期化
          this.$store.dispatch("initReviewForm");
          if (this.file != null) {
            this.$store.dispatch("initCorporateReviewFile");
          }
          this.allowLeave = true;
          this.completeModalOpen();
        } catch (e) {
          console.log(e);
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit("errorToast", "レビューの公開に失敗しました。しばらく経ってからやり直してください。");
            } else {
              this.$emit("errorToast", resError.message);
            }
          }
        }
      }
    },
    /** Zipファイルが添付されていれば登録 */
    async updateZipFile(dealId: string) {
      if (this.file == null || this.reviewData.dealType != this.zipFileType) {
        return;
      }
      const registerZipFileReq: RegisterCorporateReviewCommentZipFile = {
        dealId: dealId,
        isComment: false,
        zipFile: this.file,
      };
      try {
        await registerZipFile(registerZipFileReq);
      } catch (e) {
        throw e;
      }
    },
    /** 拡大縮小を切り替える */
    changeEnlargeFlag() {
      // margin-topの値を変更する
      let editStyle = (className: string, value: string) => {
        let subReviewDetails = document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>;
        Array.prototype.forEach.call(subReviewDetails, (item) => {
          item.style.marginTop = value;
        });
      };

      // クラスを追加する
      let addClass = (className: string, addName: string) => {
        Array.prototype.forEach.call(
          document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>,
          (item) => {
            item.classList.add(addName);
          }
        );
      };

      // クラスを削除する
      let removeClass = (className: string, removeName: string) => {
        Array.prototype.forEach.call(
          document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>,
          (item) => {
            item.classList.remove(removeName);
          }
        );
      };

      if (this.isEnlarge) {
        // 拡大中のときの処理
        document.getElementById("confirm-contents")!.style.display = "flex";
        editStyle("sub-review-detail", "0px");
        removeClass("outline", "enlarge-outline");
        removeClass("sub-column", "enlarge-sub-column");
        removeClass("order-user", "enlarge-order-user");
        removeClass("buttons", "enlarge-buttons");
        removeClass("conditions", "enlarge-conditions");
        editStyle("order-user", "30px");
        this.isEnlarge = false;
      } else {
        // 拡大していないときの処理
        document.getElementById("confirm-contents")!.style.display = "block";
        editStyle("sub-review-detail", "30px");
        addClass("outline", "enlarge-outline");
        addClass("sub-column", "enlarge-sub-column");
        addClass("order-user", "enlarge-order-user");
        addClass("buttons", "enlarge-buttons");
        addClass("conditions", "enlarge-conditions");
        editStyle("order-user", "0px");
        this.isEnlarge = true;
      }
    },
  },
  filters: {
    fileNameOthersHide: function (fileName: string) {
      return fileName.replace(/その他$/, "");
    },
    amountLocaleString: function (amount: number) {
      if (amount) {
        return amount.toLocaleString();
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return amount;
      }
    },
    remainingDays(period: string): string {
      const remain = getDaysCountToEndDate(new Date(period));
      return remain < 0 ? "期限切れ" : `残り ${remain} 日`;
    },
    formatDate(date: string, fmt: string): string {
      return moment(date).format(fmt);
    },
    lastUpdate: function (date: Date) {
      moment.locale("ja");
      if (date) {
        return moment(date).fromNow();
      } else {
        return moment().fromNow();
      }
    },
  },
});
